export type TCoordinatesFields = {
  lat?: number;
  lng?: number;
};

export type TAddressFields = {
  name?: string;
  countryId?: number;
  postCode?: string;
  city?: string;
  address?: string;
};

export type TLocationFields = {
  mode: ELocationMode;
  coordinates?: TCoordinatesFields;
  address?: TAddressFields;
};

export enum ELocationMode {
  coordinates = 'coordinates',
  address = 'address',
  fromCargo = 'fromCargo',
  loadingCustomAddress = 'loadingCustomAddress',
  unloadingCustomAddress = 'unloadingCustomAddress',
}

type TNullable<T> = { [K in keyof T]: T[K] | null };

export type TAddressFieldsInput = TNullable<TAddressFields>;
export type TCoordinatesFieldsInput = TNullable<TCoordinatesFields>;
